<template>
  <section class="commercial-form">
    <former-form
      :sections="sections"
      :loading="loading"
      :button="button"

      @error="setFieldErrors"
      @change="setFieldValue"
      @edit="setField"
      @submit="submit"
    />
  </section>
</template>

<script>
  import { mapState } from 'vuex';

  import former from '@/helpers/mixins/former';
  import preload from '@/helpers/mixins/preload';
  import dataHelper from '@/_CRUDL/helpers/data/items';

  import commercialMap, { storesMap } from '@/views/Settings/Commercial/Form/maps';
  import { defaultSectionIDs } from '@/views/Settings/Commercial/Form/sections';

  import FormerForm from '@/components/Former/Form.vue';

  export default {
    name: 'CommercialForm',
    components: {
      FormerForm,
    },
    mixins: [
      former,
      preload,
    ],
    props: {
      loading: {
        type: Boolean,
        default() {
          return false;
        },
      },
      sections: {
        type: Array,
        default() {
          return [];
        },
      },
    },
    computed: {
      ...mapState([
        'stores',
        'vehicleModels',
        'banksIntegrated',
      ]),

      button() {
        return {
          icon: 'check',
          label: 'Salvar regra',
        };
      },
    },
    mounted() {
      this.getStores();

      this.setFieldCallback(storesMap.store_id, this.changedStore);

      if (this.getField(commercialMap.has_bank)) {
        this.setFieldCallback(commercialMap.has_bank, this.changedIncludeBank);
      }

      if (this.getField(commercialMap.has_vehicle)) {
        this.setFieldCallback(commercialMap.has_vehicle, this.changedIncludeVehicle);
      }

      this.changedStore();
    },
    methods: {
      clearOptions() {
        this.$store.dispatch('vehicleModels/clear', { action: 'list' });
        this.$store.dispatch('banksIntegrated/clear', { action: 'list' });
      },
      changedStore() {
        this.clearOptions();

        const store = this.getFieldValue(storesMap.store_id);

        this.toggleSection(defaultSectionIDs.commercial_association, !store);
        this.toggleSection(defaultSectionIDs.commercial_settings, !store);
        this.toggleSection(defaultSectionIDs.commercial_products, !store);
        this.toggleSection(defaultSectionIDs.commercial_priorities, !store);

        if (store) {
          if (!this.getField(commercialMap.has_bank)
            && this.getField(commercialMap.bank_id)) {
            this.getBanks(store);
          } else if (this.getField(commercialMap.has_bank)) {
            this.changedIncludeBank();
          }

          if (!this.getField(commercialMap.has_vehicle)
            && this.getField(commercialMap.vehicle_model_id)) {
            this.getVehicles();
          } else if (this.getField(commercialMap.has_vehicle)) {
            this.changedIncludeVehicle();
          }
        }
      },
      changedIncludeBank() {
        const includeBank = this.getFieldValue(commercialMap.has_bank);
        this.setFieldSkip(commercialMap.bank_id, !includeBank);

        if (includeBank && !Object.keys(this.banksIntegrated.list.items).length) {
          this.getBanks(this.getFieldValue(storesMap.store_id));
        }
      },
      changedIncludeVehicle() {
        const includeVehicle = this.getFieldValue(commercialMap.has_vehicle);
        this.setFieldSkip(commercialMap.vehicle_model_id, !includeVehicle);

        if (includeVehicle && !Object.keys(this.vehicleModels.list.items).length) {
          this.getVehicles();
        }
      },
      getStores() {
        this.setFieldProcessing(storesMap.store_id, true);

        this.preloadStores().then(this.gotStores);
      },
      gotStores() {
        const {
          items,
        } = this.stores.list;

        this.setFieldOptions(storesMap.store_id, items);
        this.setFieldProcessing(storesMap.store_id, false);

        const ids = Object.keys(items);

        if (ids.length === 1) {
          this.setFieldValue(storesMap.store_id, items[ids[0]].id);
        }
      },
      getBanks(storeId) {
        this.setFieldProcessing(commercialMap.bank_id, true);

        this.$store
          .dispatch('banksIntegrated/list', {
            store_id: storeId,
          })
          .then(this.gotBanks);
      },
      gotBanks() {
        const id = commercialMap.bank_id;
        const items = dataHelper(this.banksIntegrated.list.items);

        this.setFieldOptions(id, items, 'name', 'id');
        this.setFieldProcessing(id, false);
      },
      getVehicles() {
        this.setFieldProcessing(commercialMap.vehicle_model_id, true);

        this.preloadVehicleModels().then(this.gotVehicles);
      },
      gotVehicles() {
        const key = commercialMap.vehicle_model_id;

        const {
          items,
        } = this.vehicleModels.list;

        this.setFieldOptions(key, Object.keys(items).reduce((state, id) => {
          const item = items[id];

          if (item.name && item.year_start && item.year_end) {
            state[id] = {
              ...item,
              name: item.version ? `${item.name} - ${item.version}` : item.name,
            };
          }

          return state;
        }, {}));

        this.setFieldProcessing(key, false);
      },
      submit() {
        this.$emit('submit');
      },
    },
  };
</script>

<style lang="scss" scoped></style>
